import { dbNamePrefix, lastSyncTimestampKeySuffix, lastUiSyncTimestampKeySuffix, storageKeyPrefix, } from '../models/Constants';
export function getSyncTimestampStorageKey(workload, dbVersion) {
    if (!workload) {
        return null;
    }
    return "".concat(storageKeyPrefix).concat(workload.toLowerCase()).concat(lastSyncTimestampKeySuffix, ".").concat(dbVersion);
}
export function getLastUiSyncTimestampStorageKey(workload) {
    if (!workload) {
        return null;
    }
    return "".concat(storageKeyPrefix).concat(workload.toLowerCase()).concat(lastUiSyncTimestampKeySuffix);
}
export function getDbName(workload, puid) {
    return "".concat(dbNamePrefix).concat(workload.toLowerCase(), "-").concat(puid);
}
//# sourceMappingURL=DatabaseUtilities.js.map